import { backUrl } from "../utils/backURL";
import { withAuthCredentials } from "../utils/authFetchOptions";

export const verifyEmail = async (verificationId) => {
    const signupReq = await fetch(`${backUrl}/email/verifyEmail`, withAuthCredentials({
        method: "POST",
        headers: {
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            verificationId
        })
    }));
    const signupRes = await signupReq.json();
    return signupRes;
};
